import styles from './styles/feedback-response-modal.module.css';

import {ReactComponent as ReSend} from '../../assets/chat-feedback/re-send.svg';

export default function FeedbackResponseModal({ answerId, feedbackType, response, error, submitFeedback }) {
    return (
        <div className={styles.wrapper}>
            <p>
                {response && '소중한 피드백 감사드려요.'}
                {error && '오류가 발생하여 피드백을 전송하지 못했습니다.'}
            </p>
            {error && 
                <button className={styles.btnReSend}onClick={() => submitFeedback(answerId, feedbackType)}>
                    재시도
                    <ReSend />
                </button>
            }
        </div>
    );
}
